var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "popoverContainer",
    staticClass: "gh-popoverContainer",
    class: [_vm.customClassContainer, `gh-popoverContainer-${_vm.popoverName}`]
  }, [_c('div', {
    staticClass: "gh-popoverHeader",
    class: _vm.customClassTrigger,
    on: {
      "click": _vm.toggleActivePopover
    }
  }, [_c('button', {
    attrs: {
      "aria-expanded": _vm.active ? 'true' : 'false'
    }
  }, [_vm._t("default")], 2), _c('div', [_c('icon-chevron', {
    staticClass: "gh-icon gh-chevron",
    class: {
      'gh-inverted': _vm.active
    }
  })], 1)]), _vm.active ? _c('div', {
    key: _vm.popoverWidth,
    ref: "ghPopoverContent",
    staticClass: "gh-popoverContent",
    class: _vm.customClassContent,
    style: {
      left: _vm.popoverLeftPosition === 'auto' ? _vm.popoverLeftPosition : `${_vm.popoverLeftPosition}px`,
      right: _vm.popoverRightPosition === 'auto' ? _vm.popoverRightPosition : `${_vm.popoverRightPosition}px`,
      top: _vm.popoverTopPosition === 'auto' ? _vm.popoverTopPosition : `${_vm.popoverTopPosition}px`,
      minWidth: _vm.popoverMinWidth === 'auto' ? _vm.popoverMinWidth : `${_vm.popoverMinWidth}px`,
      width: `${_vm.popoverWidth}px`
    },
    attrs: {
      "role": "dialog",
      "aria-label": _vm.popoverName,
      "tabindex": "-1"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.insidePopoverClick.apply(null, arguments);
      }
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "aria-label": "Close popover"
    },
    on: {
      "click": _vm.closePopover
    }
  }, [_c('icon-close', {
    staticClass: "gh-icon"
  })], 1), _vm._t("content")], 2) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };